import type { DeepString } from "@/lib/i18n";

/**
 * CSearch - polskie tłumaczenia (strona wyników wyszukiwarki).
 *
 * `groupLabel(symbol)` - mapuje symbol komponentu (np. `c_news`) na ludzką
 * nazwę sekcji wyników. Fallback do surowego symbolu gdy brak mapowania.
 */
const GROUP_LABELS: Record<string, string> = {
  c_news: "Aktualności",
  c_blog: "Blog",
  c_shop: "Sklep",
  c_faq: "Najczęstsze pytania",
  c_events_calendar: "Wydarzenia",
  c_photo_gallery: "Galerie zdjęć",
  c_video_gallery_outer: "Galerie wideo",
  c_files_to_download: "Pliki do pobrania",
  c_job_offers: "Oferty pracy",
  c_advertisements: "Ogłoszenia",
  c_descriptive_page: "Strony",
  c_procedures: "Procedury",
  c_polls: "Ankiety",
  c_browser_press_online: "Prasa online",
  c_shop_delivery_points: "Punkty odbioru",
};

export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  inputLabel: "Szukaj",
  inputPlaceholder: "Powiedz nam czego szukasz",
  submit: "Szukaj",
  resultsFor: "Wyniki dla",
  noQuery: "Wpisz frazę, aby wyszukać.",
  noResults: "Brak wyników dla podanej frazy.",
  wrongWords: "Pominięto za krótkie słowa (min. 3 znaki):",
  catalogsTitle: "Strony",
  /** `resultsCount(12)` -> "(znaleziono: 12)". */
  resultsCount: (n: number): string => `(znaleziono: ${n})`,
  /** Mapuje symbol komponentu na etykietę sekcji. */
  groupLabel: (symbol: string): string => GROUP_LABELS[symbol] ?? symbol,
} as const;

export type CSearchTranslations = DeepString<typeof pl>;
